import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { Link } from "react-router-dom"
import logo from "../image/logo.png";
const Footer = () => {
  return (
    <footer className="bg-dark text-white ">
<div className="container mt-2">
          <Row className="footer-row">
            <Col md={3} sm={5} className='box'>
              <div className="logo">
              <Link className="navbar-brand" to="/">
        <img src={logo} alt="" width={25} className='me-2' />
        E-Commerce</Link>
              </div>
              <p>This is frontend part of clothes online shopping application made by using React framework.</p>
            </Col>
            <Col md={3} sm={5} className='box'>
              <h2>About Us</h2>
              <ul>
                <li>Our Stores</li>
                <li>Terms & Conditions</li>
                <li>Privacy Policy</li>
              </ul>
            </Col>
            <Col md={3} sm={5} className='box'>
              <h2>Customer Care</h2>
              <ul>
                <li>Help Center </li>
                <li>How to Buy </li>
                <li>Track Your Order </li>
              </ul>
            </Col>
            <Col md={3} sm={5} className='box'>
              <h2>Contact Us</h2>
              <ul>
                <li>Ahmedabad, India</li>
                <li>Email: shubhamgadhiya4565@gmail.com</li>
                <li>Phone: +91 9428793010</li>
              </ul>
            </Col>
          </Row>
        </div>
    </footer>
  )
}

export default Footer
